/** unsecured HTTP URL */
export declare type HTTPURL = `http://${string}`;

/** secured HTTP URL */
export declare type HTTPSURL = `https://${string}`;

/** secured or unsecured HTTP URL */
export declare type URL = HTTPURL | HTTPSURL;

export const isHTTPURL = ( value: unknown, ): value is HTTPURL => {
	return typeof value === "string" && value.toLowerCase().startsWith("http");
}

export const isHTTPSURL = ( value: unknown, ): value is HTTPSURL => {
	return typeof value === "string" && value.toLowerCase().startsWith("https");
}

export const isURL = ( value: unknown, ): value is URL => {
	return [ isHTTPURL, isHTTPSURL ].some(fn => fn(value));
}
